import { useEffect, useState } from "react";
import api, { shortDate } from "@/lib/api";

const CATEGORIES = ["", "Storefront", "MLILY display", "Product display", "Floor stock", "Competitor display", "Damaged product", "Promotional material", "General store photo"];

export default function PhotoLibrary() {
  const [photos, setPhotos] = useState([]);
  const [category, setCategory] = useState("");
  const [selected, setSelected] = useState(null);
  useEffect(() => { api.get("/photos", { params: category ? { category } : {} }).then(r => setPhotos(r.data)); }, [category]);

  return (
    <div className="space-y-6" data-testid="photos-page">
      <div className="flex justify-between items-end gap-3 flex-wrap">
        <div>
          <h1 className="text-3xl sm:text-4xl font-heading font-black tracking-tight">Photo Library</h1>
          <p className="text-slate-600 mt-1">{photos.length} photos</p>
        </div>
        <select value={category} onChange={(e) => setCategory(e.target.value)} className="h-11 px-3 border border-slate-300 rounded-lg" data-testid="photo-category-filter">
          <option value="">All Categories</option>
          {CATEGORIES.filter(Boolean).map(c => <option key={c}>{c}</option>)}
        </select>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
        {photos.map(p => <PhotoTile key={p.id} p={p} onClick={() => setSelected(p)} />)}
        {photos.length === 0 && <div className="col-span-full text-center text-slate-500 py-16">No photos.</div>}
      </div>
      {selected && <PhotoModal p={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}

function PhotoTile({ p, onClick }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let cancel = false;
    api.get(`/photos/${p.id}/download`, { responseType: "blob" }).then(r => { if (!cancel) setUrl(URL.createObjectURL(r.data)); });
    return () => { cancel = true; };
  }, [p.id]);
  return (
    <button onClick={onClick} className="text-left card-hoverable bg-white rounded-lg overflow-hidden border border-slate-200" data-testid={`photo-tile-${p.id}`}>
      <div className="aspect-square bg-slate-100">{url && <img src={url} className="w-full h-full object-cover" alt={p.category} />}</div>
      <div className="p-2">
        <div className="text-xs font-semibold truncate">{p.customer_name}</div>
        <div className="text-[10px] text-slate-500">{p.category} • {shortDate(p.upload_date)}</div>
      </div>
    </button>
  );
}
function PhotoModal({ p, onClose }) {
  const [url, setUrl] = useState(null);
  useEffect(() => { api.get(`/photos/${p.id}/download`, { responseType: "blob" }).then(r => setUrl(URL.createObjectURL(r.data))); }, [p.id]);
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={onClose}>
      <div className="max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
        {url && <img src={url} className="w-full max-h-[80vh] object-contain rounded-lg" alt={p.category} />}
        <div className="mt-3 text-white text-sm">
          <div className="font-semibold">{p.customer_name}</div>
          <div>{p.category} • {p.agent_name} • {shortDate(p.upload_date)}</div>
          {p.notes && <div className="mt-1 text-white/80">{p.notes}</div>}
        </div>
      </div>
    </div>
  );
}
